export enum ClearDataTypes {
  Dns = "dns",
  Content = "content",
  Safety = "safety",
  Botnet = "botnet",
}
